<template>
  <div class="tab_content">
    <div class="vx-row items-center mx-2 mb-5">
      <h3 class="mr-5">Promotional Discount Price</h3>
      <vs-button color="primary" @click="active = true" type="relief">Add Discount Price</vs-button>
    </div>
    <vs-table stripe :data.sync="form.discounts">
      <template slot="thead">
        <vs-th>Sr#</vs-th>
        <vs-th>Weight Type</vs-th>
        <vs-th>Weight/Package</vs-th>
        <vs-th>Quantity</vs-th>
        <vs-th>Sales Price</vs-th>
        <vs-th>Start Date</vs-th>
        <vs-th>End Date</vs-th>
        <vs-th>Start Time</vs-th>
        <vs-th>End Time</vs-th>
        <vs-th>Action</vs-th>
      </template>

      <template slot-scope="{ data }">
        <vs-tr :key="i" v-for="(tr, i) in data">
          <vs-td>
            {{ i + 1 }}
          </vs-td>
          <vs-td>
            {{ getWeightType(form.discounts[i].weight_type) }}
          </vs-td>
          <vs-td>
            {{ form.discounts[i].weight_per_package }}
          </vs-td>
          <vs-td>
            {{ form.discounts[i].quantity }}
          </vs-td>
          <vs-td>
            {{ form.discounts[i].sales_price }}
          </vs-td>
          <vs-td>
            {{ moment(form.discounts[i].start_date, 'YYYY-MM-DD').format('MM-DD-YYYY') }}
          </vs-td>
          <vs-td>
            {{ moment(form.discounts[i].end_date, 'YYYY-MM-DD').format('MM-DD-YYYY') }}
          </vs-td>
          <vs-td>
            {{ moment(form.discounts[i].start_time, 'HH:mm:ss').format('HH:mm A') }}
          </vs-td>
          <vs-td>
            {{ moment(form.discounts[i].end_time, 'HH:mm:ss').format('HH:mm A') }}
          </vs-td>
          <vs-td>
            <div class="inline-flex">
              <vx-tooltip text="Edit Category">
                <feather-icon icon="Edit3Icon" svgClasses="h-5 w-5 mr-4 hover:text-primary cursor-pointer" @click="editDiscount(i)" />
              </vx-tooltip>
              <vx-tooltip text="Delete Category">
                <feather-icon icon="Trash2Icon" svgClasses="h-5 w-5 hover:text-danger cursor-pointer" @click="deleteDiscount(i)" />
              </vx-tooltip>
            </div>
          </vs-td>
        </vs-tr>
      </template>
    </vs-table>
    <promotional-discount-price-modal :form.sync="form" @added="addDiscountHandler" :discount.sync="discount" :active.sync="active" :popup-title.sync="popupTitle" />
  </div>
</template>

<script>
import moment from 'moment'
import PromotionalDiscountPriceModal from '@/views/products/components/PromotionalDiscountPriceModal.vue'
import { weightMixins } from '@/utils/weightType'
import { mapActions } from 'vuex'

export default {
  name: 'PromotionalDiscountPriceTab',
  components: {
    PromotionalDiscountPriceModal
  },
  props: {
    form: {
      type: Object
    }
  },
  data() {
    const emptyDiscount = {}
    return {
      active: false,
      emptyDiscount,
      discount: emptyDiscount,
      popupTitle: 'Add Volume Discount Price'
    }
  },
  mixins: [weightMixins],
  methods: {
    moment,
    ...mapActions('product', ['removeDiscountById', 'create_promotional_discount']),
    async addDiscountHandler(discount) {
      if (this.form.id) {
        // insert promotional discount - if product already inserted
        const payload = {
          productId: this.form.id,
          id: discount.id,
          ...discount
        }
        await this.create_promotional_discount(payload)
      }

      if (discount.localId >= 0) {
        this.form.discounts[discount.localId] = discount
      } else {
        this.$emit('update:form', {
          ...this.form,
          discounts: [...this.form.discounts, { ...discount, localId: this.form.discounts.length }]
        })
      }
      this.discount = {}
    },
    editDiscount(i) {
      this.discount = { ...this.form.discounts[i] }
      this.active = true
    },
    async deleteDiscount(i) {
      const discount = this.form.discounts[i]
      try {
        if (discount.id) {
          const { message } = await this.removeDiscountById(discount.id)
          this.$vs.notify({
            title: 'Success',
            text: message,
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'success'
          })
        }
        const discounts = [...this.form.discounts]
        discounts.splice(i, 1)
        this.$emit('update:form', {
          ...this.form,
          discounts
        })
      } catch ({ message }) {
        this.$vs.notify({
          title: 'Error',
          text: message,
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'danger'
        })
      }
    }
  }
}
</script>
